import Vue from 'vue'
/**
 * code:123按钮编码
 * type:'button' || 'model' 权限级别
 * mode:''显示方式默认隐藏'none' || 'disabled' || 'mask'
 * v-authority="{code:123,type:'model',mode:'none'}"
 */

// 权限定义全局的指定
const authority = Vue.directive('authority', {
    inserted: function (el, binding, vnode) {
        if (!access(binding.value.code)) {
        // el.setAttribute('disabled',true)
            checkMode(el, binding.value.mode)
        }
    // console.log(el)
    // console.log(binding)
    // console.log(vnode)
    }
})

function access (permission) {
    let access = localStorage.getItem('permissionCodeList')
    if (access) {
        let permissions = new Set(access.split(','))
        return permissions.has(permission + '')
    } else {
        return false
    }
}

function checkMode (el, mode = 'none') {
    if (mode == 'none') {
        el.style.display = 'none'
    } else if (mode == 'disabled') {
        el.setAttribute('disabled', true)
    } else if (mode == 'mask') {
        el.classList.add('mask')
    }
}

export {
    authority
}
